import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getSettings({ commit, dispatch, gettings }) {
    return axios.get('/api/parseOptions').then(response => {
      const options = response.data
      return axios.get('/api/revUsageFields').then(response => {
        const revUsageFields = response.data
        return axios.get('/api/cdmFields').then(response => {
          const fields = response.data
          return { fields, options, revUsageFields }
        })
      })
    })
  },
  getApproverWorkflows({ commit, dispatch, gettings }) {
    return axios.get('/api/approverWorkflows').then(response => {
      const approvers = response.data
      return { approvers }
    })
  },
}
